export type ApiGetResponse = {
  data: {
    biller: {
      code: string;
      name: string;
    };
  };
};
export const getBpayBiller = ({ billerCode }): Promise<ApiGetResponse> =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {
          biller: {
            code: billerCode,
            name: "Fake biller Pty Ltd",
          },
        },
      });
    }, 1000);
  });

export type ApiPostResponse = {
  data: {
    masked_mobile: string;
    actions: { name: string; href: string }[];
  };
};

export const postBpayDetails = (): Promise<ApiPostResponse> =>
  new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        data: {
          masked_mobile: "04xxxxx111",
          actions: [
            { name: "verify-otp", href: "mock" },
            { name: "resend-otp", href: "mock" },
          ],
        },
      });
    }, 1000);
  });
